import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { SignupSuccess } from './TheNightlySignupSuccess'
import { QueryClient, QueryClientProvider } from 'react-query'

const queryClient = new QueryClient()

export const TheNightlySignupSuccessRegistration = createRegisterableComponent(
    'thenightly-signup-success',
    () => {
        return (
            <QueryClientProvider client={queryClient}>
                <SignupSuccess />
            </QueryClientProvider>
        )
    },
)
